import { jsx, Fragment } from 'react/jsx-runtime';
import { Card } from '../Card/Card.es.js';
import { useAccordionPanelContext } from './AccordionPanel.Context/index.es.js';

const AccordionPanelCard = ({ children })=>{
    const [{ onCard }] = useAccordionPanelContext();
    // Wrapper around accordion to conditionally display on a Card
    if (onCard) {
        return jsx(Card, {
            children: jsx(Card.Content, {
                children: children
            })
        });
    }
    return jsx(Fragment, {
        children: children
    });
};
AccordionPanelCard.displayName = 'AccordionPanelCard';

export { AccordionPanelCard };
//# sourceMappingURL=AccordionPanel.Card.es.js.map
